import React, { useEffect, useRef, useState } from "react";
import { UploadIconBlue, WarningIcon } from "../../../assets/svgs";
import { API, Storage } from "aws-amplify";
import { LoadingOutlined, ZoomInOutlined } from "@ant-design/icons";
import {
  ApprovalStatus,
  ImageFile,
  PdfData,
  Position,
  PositionImage,
  UploadStatus,
  UserOrder,
} from "../../../interfaces";
import Modal from "../../modal/Modal";
import {
  asyncForEach,
  calculateImageV2,
  createPdfThumbnail,
  updateProgress,
  getRatio,
  getOutline,
  createImgThumbnail,
  resetInset,
  getFileSizeInMb,
  getFileNameWithoutFolderName,
} from "../../../utils";
import config from "../../../aws-exports";
import ImageDetail from "../../account/ImageDetail";
import { toast } from "react-toastify";
import SendPrintdata from "../../account/SendPrintdata";
import { useTranslation } from "react-i18next";
import PdfPreview from "../../account/PdfPreview";
import ImagePreviewLoading from "../../ImagePreviewLoading";
import { Loader, Text } from "@mantine/core";
import ImageOutline from "../../image/ImageOutline";
import { Textarea } from "@mantine/core";
import { FaDownload, FaCheck, FaUpload, FaTimes } from "react-icons/fa";
import useHandleS3 from "../../../hooks/useHandleS3";
import DeclineAllModal from "./DeclineAllModal";
import AcceptAllModal from "./AcceptAllModal";
import useOrderPosition from "../../../hooks/useOrderPosition";
import useOrder from "../../../hooks/useOrder";
import BulkPhotoView from "../../common/BulkPhotoView";

type Props = {
  item: Position;
  index: number;
  order: UserOrder;
  mutate: (state: UserOrder) => void;
};
interface RecentUrls {
  [key: string]: string;
}

interface IPositionImageFiles extends PositionImage {
  size: number;
}

var request: XMLHttpRequest | null = null;

const AdminOrderDataCard: React.FC<Props> = ({
  item,
  order,
  mutate,
  index,
}) => {
  const [signedUrls, setSignedUrls] = useState<Record<string, string>>({});
  const [recentUrls, setRecentUrls] = useState<RecentUrls>({});

  const [url, setUrl] = useState<string | null>(null);
  const [base64, setBase64] = useState<string>();
  const [current, setCurrent] = useState<PositionImage | null>(null);
  const [open] = useState(
    index === 0 ||
      (item?.positionImage && item.positionImage?.length > 0) ||
      false
  );
  const { t } = useTranslation();
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [approveModalVisible, setApproveModalVisible] =
    useState<boolean>(false);
  const [declineModalVisible, setDeclineModalVisible] =
    useState<boolean>(false);

  const [uploadStatus, setUploadStatus] = useState<UploadStatus | undefined>();
  const [approved, setApproved] = useState<boolean>(false);
  const [uploadMode, setUploadMode] = useState<boolean>(false);
  const [type, setType] = useState<"image" | "pdf" | null>(null);
  const [image, setImage] = useState<File | null>(null);
  const [outline, setOutline] = useState<string>();
  const [dpi, setDpi] = useState<number>();
  const [ratio, setRatio] = useState<{
    x: number;
    y: number;
    fit: boolean;
  }>();
  const { handleOrderUpdate } = useOrder();
  const [pdfKey, setPdfKey] = useState<string>();
  const [isLarge, setIsLarge] = useState<boolean>(false);
  // @ts-expect-error type exists
  const [galleryImage, setGalleryImage] = useState<string | null>(null);
  const [files, setFiles] = useState<IPositionImageFiles[]>([]);
  const [numPages, setNumPages] = useState<number>(0);
  const inputRef: any = useRef();
  const { listImagesByOrderId } = useHandleS3({
    data: order,
  });
  const { dontApproveImage, approveImage } = useOrderPosition(order);

  const galleryPreview = (imgUrl?: string | null) => {
    if (imgUrl) {
      setGalleryImage(imgUrl);
    } else {
      const preview = document.getElementById(
        `image-preview_${index}`
      ) as HTMLImageElement | null;
      if (preview) setGalleryImage(preview.src || null!);
    }
  };

  const setSignedUrl = async (url: string) => {
    if (url) {
      const signedUrl = await Storage.get(url);
      setSignedUrls({ ...signedUrls, [url]: signedUrl });
    }
  };
  const loadPdf = async (key: string) => {
    if (recentUrls[key]) {
      setUrl(recentUrls[key]);
      onModalOpen();
      return;
    }

    const signedUrl = await Storage.get(key);
    setRecentUrls({ ...recentUrls, [key]: signedUrl });
    setUrl(signedUrl);
    onModalOpen();
  };

  const fetchImage = async () => {
    const urls: Record<string, string> = {};

    await asyncForEach(item.positionImage, async (position: PositionImage) => {
      const url: string = await Storage.get(position.thumbnail);
      urls[position.thumbnail] = url;
    });

    setSignedUrls(urls);
  };
  const loadImage = async (key: string) => {
    if (recentUrls[key]) {
      setUrl(recentUrls[key]);
      onModalOpen();
      return;
    }

    const signedUrl = await Storage.get(key);
    setRecentUrls({ ...recentUrls, [key]: signedUrl });
    setUrl(signedUrl);
    onModalOpen();
  };

  const onImageLoad = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    setOutline(getOutline({ image: e.currentTarget, item }));
  };

  const handleDownload = async (key: string) => {
    const signedUrl = await Storage.get(key);
    const element = document.createElement("a");
    element.style.display = "none";
    element.setAttribute("href", signedUrl);
    element.setAttribute("target", "_blank");
    element.setAttribute("download", key);
    document.body.appendChild(element);
    element.click();
    element.remove();
  };

  const fetchingPositionImage = async () => {
    const file =
      item?.positionImage?.map(async (item) => {
        try {
          const fetchFiles = listImagesByOrderId.find(
            (s3Item) => s3Item.key === (item.pdfKey ?? item.key)
          );

          if (fetchFiles?.size) {
            return {
              key: item.key,
              size: fetchFiles.size,
              pdfKey: item.pdfKey,
              // dpi: item.dpi,
              // aspectRatio: item.aspectRatio,
              approvalStatus: item.approvalStatus,
              quantity: item.quantity,
              thumbnail: item.thumbnail,
              comment: item.comment,
              filledPositionArticleNumber: item.filledPositionArticleNumber,
            };
          }
        } catch (error) {
          if (error && (error as Error).message) {
            toast.error((error as Error).message);
          } else {
            toast.error("We are unable to load image details contact admin.");
          }
          return undefined;
        }
      }) || [];
    const response = await Promise.all(file);
    setFiles(response.filter((i) => i) as IPositionImageFiles[]);
  };

  useEffect(() => {
    if (!item || (item && !item.positionImage)) return;
    fetchingPositionImage();
  }, [listImagesByOrderId, item]);

  const handleUpload = () => {
    if (item.White) return;
    setTimeout(() => inputRef.current.click(), 30);
  };

  const onDeclineModalOpen = () => {
    setDeclineModalVisible(true);
  };

  const onApproveModalOpen = () => {
    setApproveModalVisible(true);
  };

  const onDeclineImage = async (
    rejectedDescription: string,
    rejectedReason: string,
    files: ImageFile[]
  ) => {
    setDeclineModalVisible(false);
    const updatedOrder = await dontApproveImage(
      rejectedDescription,
      rejectedReason,
      files,
      current,
      item,
      order
    );
    if (updatedOrder) {
      mutate(updatedOrder);
    }
    toast.success(t("imageRejected"));
  };

  const onApproveImage = async (acceptedDescription: string) => {
    setApproveModalVisible(false);
    const updatedOrder = await approveImage(
      acceptedDescription,
      current,
      item,
      order
    );
    if (updatedOrder) {
      mutate(updatedOrder);
    }
    toast.success(t("imageApproved"));
  };

  useEffect(() => {
    item.positionImage && fetchImage();

  }, []);

  const onModalOpen = () => {
    setModalVisible(true);
  };

  const onModalClose = () => {
    if (request) {
      request.abort();
    }

    resetState();

    const preview = document.getElementById(
      `image-preview_${index}`
    ) as HTMLImageElement;

    setTimeout(() => {
      setImage(null);
      setType(null);
      if (preview) preview.src = "";
    }, 300);
  };

  const onComplete = async (updated: PositionImage) => {
    const positionImage: PositionImage[] = [...(item.positionImage || [])].map(
      (image) => {
        if (image.key === current?.key) {
          return updated;
        }
        return image;
      }
    );
    const positions = order.positions.map((position: Position) => {
      if (
        position.articleNumber === item.articleNumber &&
        position.heightByMm === item.heightByMm &&
        position.widthByMm === item.widthByMm
      ) {
        return { ...position, positionImage };
      }
      return {
        ...position,
        positionImage: position.positionImage ? position.positionImage : [],
      };
    });
    const updatedOrder = await handleOrderUpdate({ id: order.id, positions });
    if (updatedOrder) mutate(updatedOrder);
    setSignedUrl(updated.thumbnail);
    setCurrent(updated);
    setUploadMode(false);
    if (current) {
      Storage.remove(current.key);
      Storage.remove(current.thumbnail);
    }
    setUploadStatus(UploadStatus.DONE);
    setTimeout(() => onModalClose(), 300);
  };

  const handleS3Upload = async () => {
    if (!dpi || !ratio || !current || !image) return;

    if (isLarge && !pdfKey) {
      toast.info(t("uploadInProgress"));
      return;
    }

    if (numPages > 1) {
      toast.error(t("moreThan1Page"));
      return;
    }

    if (!ratio?.fit) {
      toast.error(t("imageDoesNotMatch"));
      return;
    }

    // Uploaded large PDF file key is present
    if (pdfKey) {
      setUploadStatus(UploadStatus.PREUPLOADED);

      const currentUpdated: PositionImage = {
        ...current,
        key: `${pdfKey}.jpg`,
        pdfKey,
        thumbnail: `${pdfKey}x300.jpg`,
        // dpi,
        // aspectRatio: ratio,
      };

      await onComplete(currentUpdated);
    } else {
      setUploadStatus(UploadStatus.UPLOADING);

      const fileName = `${Date.now()}-${image.name}`;
      const thumbnailFileName = `x300-${fileName}`;
      const thumbnail = await (type === "image"
        ? createImgThumbnail(index, image.name, image.type)
        : createPdfThumbnail(image.name, image.type));
      const res = await Storage.put(thumbnailFileName, thumbnail);

      const region = config.aws_user_files_s3_bucket_region;
      const bucketName = config.aws_user_files_s3_bucket;

      const signedUrl = await API.get(
        "s3UploadApi",
        `/?fileName=public/${fileName}&region=${region}&bucketName=${bucketName}`,
        {}
      );

      request = new XMLHttpRequest();
      request.responseType = "json";

      const line = document.getElementById("upload-line") as HTMLElement;
      const progress = document.getElementById(
        "upload-progress"
      ) as HTMLElement;

      request.upload.addEventListener("progress", (e: any) => {
        updateProgress({ line, progress, e });
      });

      request.addEventListener("load", async () => {
        if (request?.status === 200) {
          setUploadStatus(UploadStatus.DONE);

          const currentUpdated: PositionImage = {
            ...current,
            key: fileName,
            pdfKey,
            thumbnail: res.key,
            // dpi,
            // aspectRatio: ratio,
          };

          await onComplete(currentUpdated);
        } else {
          request = null;
        }
      });

      request.addEventListener("error", (e: any) => {
        request = null;
        console.log("error:", e);
      });

      request.open("put", signedUrl);
      request.send(image);
    }
  };

  const resetState = () => {
    setModalVisible(false);
    setApproved(false);
    setUploadStatus(undefined);
    setPdfKey(undefined);
    setIsLarge(false);
    setTimeout(() => {
      setCurrent(null);
      setUrl(null);
      setOutline(undefined);
      setNumPages(0);
      setDpi(undefined);
      setRatio(undefined);
      resetInset(index);
    }, 300);
  };

  const onInputChange = (e: any) => {
    if (!current) return;

    const file = e.target.files[0];
    e.target.value = null;

    if (!/png|jpeg|jpg|pdf|epub/.test(file?.type)) {
      toast.warn(t("unsupportedFile"));
      return;
    }

    setUploadMode(true);

    setUrl(null);
    setImage(null);
    setDpi(undefined);
    setRatio(undefined);
    setOutline(undefined);
    setNumPages(0);
    onModalOpen();

    if (/png|jpeg|jpg/.test(file.type)) {
      setType("image");
      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = () => {
        const width = img.naturalWidth;
        const height = img.naturalHeight;

        const { _ratio, _dpi } = calculateImageV2({ width, height, item });
        setRatio(_ratio);
        setDpi(_dpi);
        setImage(file);

        if (_ratio.fit) {
          const preview = document.getElementById(
            `image-preview_${index}`
          ) as HTMLImageElement;
          preview.src = img.src;
          setUrl(img.src);
        }
      };
    } else if (/pdf|epub/.test(file.type)) {
      setType("pdf");
      setBase64(URL.createObjectURL(file));
      setTimeout(() => setImage(file), 100);
    } else {
      toast.warn(t("unsupportedFile"));
    }
  };

  const setPdfData = (pdfData: PdfData) => {
    const { _ratio, _dpi, _key, _numPages, _isLarge } = pdfData;

    if (_numPages) setNumPages(_numPages);

    if (image) {
      if (_isLarge) setIsLarge(true);
      if (_key) setPdfKey(_key);
      if (_ratio) setRatio(_ratio);
      if (_dpi) setDpi(_dpi);
    }
  };

  return (
    <div className={`position-item ${open ? "opened" : ""}`}>
      <div className="position-item__body">
        {files.map((positionItem, idx) => {
          const {
            size,
            key,
            pdfKey,
            // dpi,
            // aspectRatio,
            approvalStatus,
            quantity,
            thumbnail,
            comment,
            filledPositionArticleNumber,
          } = positionItem;
          const currentValue: PositionImage = {
            key,
            pdfKey,
            // dpi,
            // aspectRatio,
            approvalStatus,
            quantity,
            thumbnail,
            filledPositionArticleNumber,
          };

          return (
            <div key={idx} className="mb-30">
              <div
                className="card-auto p-16"
                style={{
                  border:
                    approvalStatus === ApprovalStatus.Yes
                      ? "3px solid #34C759"
                      : approvalStatus === ApprovalStatus.No
                      ? "3px solid crimson"
                      : 0,
                }}
              >
                <div className="pb-16">
                  <BulkPhotoView
                    file={thumbnail}
                    isPdf={key.includes(".pdf")}
                  />
                </div>
                <div className="grid upload-file">
                  <div></div>
                  <div>
                    <h4 className="overflow-wrap-break-word">
                      {getFileNameWithoutFolderName(key)}
                    </h4>
                    <span>{getFileSizeInMb(size)}MB</span>
                    <br />
                    <br />

                    <Textarea
                      readOnly
                      value={comment ?? ""}
                      placeholder={t("commentField")}
                      label={<p>{t("commentField")}</p>}
                      radius={"md"}
                      minRows={4}
                    />
                    <div className="row gap-8 mt-10">
                      <button
                        onClick={() => {
                          setCurrent(currentValue);
                          onApproveModalOpen();
                        }}
                        disabled={approvalStatus === ApprovalStatus.Yes}
                        className="card-action-button p-4 row row-center row-v-center"
                      >
                        <FaCheck />
                      </button>

                      <button
                        onClick={() => {
                          setCurrent(currentValue);
                          onDeclineModalOpen();
                        }}
                        disabled={approvalStatus === ApprovalStatus.No}
                        className="card-action-button p-4 row row-center row-v-center"
                      >
                        <FaTimes />
                      </button>

                      <button
                        onClick={() => {
                          setCurrent(currentValue);
                          handleUpload();
                        }}
                        className="card-action-button p-4 row row-center row-v-center"
                      >
                        <FaUpload />
                      </button>
                    </div>
                  </div>
                  <div className=" row row-v-start  gap-16 row-column ">
                    {true && (
                      <div
                        className="card-action-button p-4 row row-center row-v-center"
                        onClick={() => {
                          if (
                            !positionItem.pdfKey &&
                            /\.pdf|epub+$/i.test(key)
                          ) {
                            setType("pdf");
                            loadPdf(key);
                          } else {
                            setType("image");
                            loadImage(key);
                          }
                          setCurrent(currentValue);
                        }}
                      >
                        <WarningIcon />
                      </div>
                    )}
                    <button
                      onClick={() => handleDownload(pdfKey || key)}
                      className="card-action-button p-4 row row-center row-v-center"
                    >
                      <FaDownload />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        <input
          accept=".png, .jpeg, .jpg, .pdf, .epub"
          style={{ display: "none" }}
          ref={inputRef}
          type="file"
          onChange={onInputChange}
        />
      </div>

      <Modal compact visible={modalVisible} onClose={onModalClose}>
        {current && !image ? (
          <>
            <div className="modal-preview">
              <div className="image-wrapper">
                {outline && (
                  <div className="image-wrapper__info">
                    <div className="marker-line" />
                    <Text color="#fa00ff" weight={700}>
                      {t("cutting")}
                    </Text>
                  </div>
                )}
                <div className="image-container">
                  <ImageOutline outline={outline} />
                  <img
                    style={{
                      visibility: url ? "visible" : "hidden",
                      display: type === "image" && url ? "block" : "none",
                    }}
                    src={url || ""}
                    id={`image-preview_${index}`}
                    className="image-preview"
                    onLoad={onImageLoad}
                    alt=""
                    onClick={() => galleryPreview()}
                  />
                </div>
              </div>
              {type === "image" ? (
                <>{!url && <ImagePreviewLoading />}</>
              ) : type === "pdf" ? (
                <>
                  {url ? (
                    <PdfPreview
                      item={item}
                      url={url}
                      outline={outline}
                      setPdfData={setPdfData}
                      previewPdf={galleryPreview}
                      setOutline={setOutline}
                    />
                  ) : (
                    <Loader />
                  )}
                </>
              ) : (
                <LoadingOutlined style={{ fontSize: 28 }} />
              )}
              {type === "image" && url && (
                <>
                  <div
                    onClick={() => galleryPreview()}
                    className="image-action"
                  >
                    <span>{t("imageFullScreen")}</span>
                    <ZoomInOutlined style={{ fontSize: 28, marginLeft: 5 }} />
                  </div>
                  <span className="text-small">
                    {t("imagePreviewDescription")}
                  </span>
                </>
              )}
            </div>
            <div className="modal-info">
              <ImageDetail
                productRatio={getRatio(item.widthByMm, item.heightByMm)}
                {...(!uploadMode
                  ? {
                      // dpi: current?.dpi,
                      // aspectRatio: current?.aspectRatio,
                      numPages,
                    }
                  : {
                      dpi,
                      ratio,
                      numPages,
                    })}
              />
            </div>
          </>
        ) : (
          <>
            <div className="modal-preview">
              {/* Image */}
              <div className="image-wrapper">
                {outline && type === "image" && (
                  <div className="image-wrapper__info">
                    <div className="marker-line" />
                    <Text color="#fa00ff" weight={700}>
                      {t("cutting")}
                    </Text>
                  </div>
                )}
                <div className="image-container">
                  <ImageOutline outline={outline} />
                  <img
                    style={{
                      visibility: image ? "visible" : "hidden",
                      display:
                        type === "image" && ratio?.fit ? "block" : "none",
                      maxHeight: type === "image" && ratio?.fit ? "400px" : "0",
                    }}
                    id={`image-preview_${index}`}
                    className="image-preview"
                    onLoad={onImageLoad}
                    alt=""
                    onClick={() => galleryPreview()}
                  />
                </div>
              </div>
              {image ? (
                <>
                  {/* PDF */}
                  {type === "pdf" && (
                    <PdfPreview
                      item={item}
                      image={image}
                      base64={base64}
                      outline={outline}
                      url={base64 || URL.createObjectURL(image)}
                      setPdfData={setPdfData}
                      previewPdf={galleryPreview}
                      setOutline={setOutline}
                    />
                  )}
                  {ratio && !ratio?.fit && (
                    <div className="row row-center">
                      <span className="text-center" style={{ fontSize: 18 }}>
                        {t("imageDoesNotMatch")}
                      </span>
                    </div>
                  )}
                </>
              ) : (
                <>{type === "image" ? <ImagePreviewLoading /> : <Loader />}</>
              )}
              {type === "image" && url && ratio && ratio?.fit && (
                <>
                  <div
                    onClick={() => galleryPreview()}
                    className="image-action"
                  >
                    <span>{t("imageFullScreen")}</span>
                    <ZoomInOutlined style={{ fontSize: 28, marginLeft: 5 }} />
                  </div>
                  <span className="text-small">
                    {t("imagePreviewDescription")}
                  </span>
                </>
              )}
            </div>
            <div className="modal-info">
              <ImageDetail
                productRatio={getRatio(item.widthByMm, item.heightByMm)}
                {...(!uploadMode
                  ? {
                      // dpi: current?.dpi,
                      // aspectRatio: current?.aspectRatio,
                      numPages,
                    }
                  : {
                      dpi,
                      ratio,
                      numPages,
                    })}
              />
            </div>
            <div
              className="choose-another-file"
              style={{ pointerEvents: !!uploadStatus ? "none" : "unset" }}
            >
              <span onClick={handleUpload}>
                <span>{t("chooseAnotherFile")} </span>
                <UploadIconBlue />
              </span>
            </div>
            {ratio && ratio?.fit && (
              <SendPrintdata
                uploadStatus={uploadStatus}
                approved={approved}
                setApproved={setApproved}
                image={image}
                handleS3Upload={handleS3Upload}
                isLarge={isLarge}
              />
            )}
          </>
        )}
      </Modal>
      {approveModalVisible && (
        <AcceptAllModal
          modalVisible={approveModalVisible}
          setModalVisible={setApproveModalVisible}
          onSuccess={(acceptedDescription: string) =>
            onApproveImage(acceptedDescription)
          }
          successButtonName={"approve"}
          title={"approvePrintdata"}
          contentStyle={"pb-16"}
        />
      )}
      {declineModalVisible && (
        <DeclineAllModal
          current={current}
          modalVisible={declineModalVisible}
          setModalVisible={setDeclineModalVisible}
          onSuccess={(
            rejectedDescription: string,
            rejectedReason: string,
            files: ImageFile[]
          ) => onDeclineImage(rejectedDescription, rejectedReason, files)}
          successButtonName={"doNotApprove"}
          title={"doNotApprovePrintdata"}
          contentStyle={"pb-16"}
        />
      )}
    </div>
  );
};

export default AdminOrderDataCard;
